import {Howl} from 'howler';

var loadedAudio = {};

function playEffect(file) {
  if (!window.AUDIOENABLED) return;

  if (loadedAudio[file]) {
    loadedAudio[file].play();
  } else {
    loadedAudio[file] = new Howl({
      src: [file],
      autoplay: true
    });
  }
}

function loadAudio(...files) {
  if (!window.AUDIOENABLED) return;

  files.forEach(file => {
    if (!loadedAudio[file]) {
      loadedAudio[file] = new Howl({src: [file]});
    }
  });
}

var currentFile, current1sfile, currentBg, currentBg1s, prevFade = 1;

function playBg(file, oneshot = null, callback = () => {}, waitFor) {

  var oldCurrentFile = currentFile;
  var oldCurrent1sFile = current1sfile;
  currentFile = file;
  current1sfile = oneshot;

  if (currentBg) currentBg.off('load');
  if (currentBg1s) currentBg1s.off('load');
  if (currentBg1s && currentBg1s.playing()) currentBg1s.fade(1, 0, 1000);


  if (!window.AUDIOENABLED || !file) {
    if (currentBg && currentBg.playing()) currentBg.fade(1, 0, 1000);
    if (waitFor) {
      waitFor.then(callback);
      return;
    } else {
      return callback();
    }
  }

  if (file != oldCurrentFile || !currentBg || !(currentBg.state() == 'loading' || currentBg.playing())) {
    if (currentBg && currentBg.playing()) currentBg.fade(1, 0, 1000);
    currentBg = new Howl({
      src: [file],
      loop: true,
      volume: 0
    });
    prevFade = 1;
  }

  if (oneshot) {
    currentBg1s = new Howl({
      src: [oneshot]
    });
  } else {
    currentBg1s = null;
  }

  function loaded() {
    if (currentBg.state() == 'loaded' && (currentBg1s == null || currentBg1s.state() == 'loaded')) {
      currentBg.play();
      currentBg.fade(0, 1, 500);
      currentBg.off('load');
      if (currentBg1s) {
        currentBg1s.play();
        currentBg1s.off('load');
      };
      callback();
      loaded = _ => {};
    }
  }

  var loadFn = loaded;

  if (waitFor) {
    loadFn = function() {
      waitFor.then(loaded);
    };
  }

  currentBg.on('load', loadFn);
  if (currentBg1s) currentBg1s.on('load', loadFn);
  loadFn();

  return {
    bg: currentBg,
    oneshot: currentBg1s
  };
}


function toggleAudio() {
  window.AUDIOENABLED = !window.AUDIOENABLED;

  if (window.AUDIOENABLED) {
    if (currentFile) {
      playBg(currentFile);
    }
  } else {
    if (currentBg && currentBg.playing()) {
      currentBg.fade(1, 0, 300);
      currentBg.once('fade', _ => currentBg.stop());
    }
    if (currentBg1s && currentBg1s.playing()) {
      currentBg1s.fade(1, 0, 300);
      currentBg1s.once('fade', _ => currentBg1s.stop());
    };
  }

  try {
    window.localStorage.setItem('audioEnabled', window.AUDIOENABLED);
  } catch (e) {}

  return window.AUDIOENABLED;
}

function fadeBgTo(to) {
  if (currentBg && currentBg.playing()) {
    currentBg.fade(prevFade, to, 500);
    prevFade = to;
  }
  if (currentBg1s && currentBg1s.playing()) {
    currentBg1s.fade(prevFade, to, 500);
    prevFade = to;
  }
}

export { playEffect, loadAudio, playBg, toggleAudio, fadeBgTo };
